import React from "react";
import { PageHero, PageBody } from "./_shared";
import { useNursing } from "./NursingLayout";
import BodyMembersTable from "@/components/BodyMembersTable";

export default function GoverningBodyPage() {
  const data = useNursing();
  const list = data.governing_body || [];
  return (
    <div data-testid="nur-gb-page-wrap">
      <PageHero eyebrow="About" title="Governing Body Members" />
      <PageBody>
        <BodyMembersTable members={list} theme="emerald" testidPrefix="nur-gb-page" />
      </PageBody>
    </div>
  );
}
